import React from 'react'
import createIcon from '@/lib/create-icon'

export const MinusSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.3335 8H12.6668" stroke="currentColor" strokeOpacity="0.3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,

)
